// TODO: remove this when nuxt gets its shit together
export const NUXT_DEFAULT_ERROR_MESSAGE = 'nuxtDefault404ErrorMessage'
